import { render, staticRenderFns } from "./FragmentHtml.vue?vue&type=template&id=24fd4066&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports